import { chakra } from '@chakra-ui/react';

export const Prose = chakra('div', {
  base: {
    color: 'fg',
    fontSize: 'sm',
    lineHeight: '1.7em',
    '& p': {
      marginTop: '1em',
      marginBottom: '1em',
      fontSize: 'xs',
    },
    '& a': {
      color: 'fg',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
      fontWeight: '500',
    },
    '& strong': {
      fontWeight: '600',
    },
    '& ul': {
      marginTop: '0',
      marginBottom: '0',
      paddingLeft: '1.6em',
      listStyleType: 'disc',
    },
    '& ol': {
      marginTop: '0',
      marginBottom: '0',
      paddingLeft: '1.6em',
      listStyleType: 'decimal',
    },
    '& li': {
      marginTop: '0',
      marginBottom: '0',
      fontSize: 'xs',
      lineHeight: '2em',
    },
    '& code': {
      fontSize: '0.875em',
      borderRadius: 'md',
      borderWidth: '1px',
      padding: '0.25em',
    },
    '& :is(h1, h2, h3, h4, h5, h6)': {
      color: 'fg',
      fontWeight: '600',
    },
    '& h2': {
      fontSize: 'md',
      my: '0.5em',
    },
    '& h3': {
      fontSize: '1.25em',
    },
    '& :is(h1, h2, h3, h4, h5, h6) + *': {
      marginTop: '0',
    },
    '& > :first-child': {
      marginTop: '0',
    },
    '& > :last-child': {
      marginBottom: '0',
    },
  },
});
